
import { RevButton } from '@ds/components/Button'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'
import { openModal } from '@ds/components/ModalBase'
import { RevStickyBar } from '@ds/components/StickyBar'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import { addToCart } from '@http/endpoints'
import { InstallmentPaymentPrice } from '@payment'
import { trackAddToCart, trackErrors } from '@tracking/events'

import PriceWrapper from '../PriceWrapper'
import { SWAP_ERROR, SWAP_NONE } from '../SwapBlock'

import translations from './AddToCart.translations'

const POSITION_Y_STICKYBAR_DISPLAY = -100

export default {
  components: {
    RevButton,
    RevContainer,
    RevIllustration,
    InstallmentPaymentPrice,
    PriceWrapper,
    RevStickyBar,
  },

  inject: ['openErrorToast'],

  props: {
    installmentMonthlyPaymentPlan: {
      type: Object,
      default: null,
    },
    isVatIncluded: {
      type: Boolean,
      required: false,
      default: false,
    },
    listingId: {
      type: Number,
      required: true,
    },
    originalPrice: {
      type: Object,
      default: () => ({}),
    },
    price: {
      type: Object,
      required: true,
    },
    priceColor: {
      type: String,
      required: true,
    },
    priceLabel: {
      type: String,
      required: true,
    },
    priceEmphasis: {
      type: String,
      required: true,
    },
    productImage: {
      type: Object,
      default: () => ({}),
    },
    swapStatus: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    trackingInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showBottomBar: false,
    }
  },

  computed: {
    ...mapGetters({
      experiments: 'flags/getExperiments',
      searchRelatedId: 'landingSearch/queryID',
      searchIndex: 'landingSearch/sortDefaultValue',
    }),

    translations: () => translations,

    shouldDisplayInstallmentPaymentPrice() {
      return (
        this.installmentMonthlyPaymentPlan !== null &&
        this.experiments.splitPaymentWording === 'splitPaymentWordingDisplayed'
      )
    },
    monthlyPaymentPlan() {
      return this.installmentMonthlyPaymentPlan
    },

    addToCartButtonLabel() {
      return this.$t(this.translations.addToCart)
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    async addToCart() {
      const productTrackingInfo = {
        ...this.trackingInfo,
        quantity: 1,
      }

      trackAddToCart({
        product: productTrackingInfo,
      })

      try {
        await this.$store.dispatch('http/request', {
          request: addToCart,
          body: {
            listing_id: this.listingId,
            searchRelatedQuery: {
              id: this.searchRelatedId,
              index: this.searchIndex,
            },
          },
        })
      } catch (error) {
        this.openErrorToast()

        trackErrors({
          zone: 'add_to_cart',
          message: error?.payload?.detail ?? 'unknown_error',
        })

        return
      }

      const shouldDisplaySwapModal =
        this.swapStatus === SWAP_NONE || this.swapStatus === SWAP_ERROR

      if (!shouldDisplaySwapModal) {
        openModal(MODAL_NAMES.PRODUCT.ADD_TO_CART)

        return
      }

      if (shouldDisplaySwapModal) {
        openModal(MODAL_NAMES.BUYBACK.SWAP_ATC)
      }
    },
    handleScroll() {
      window.requestAnimationFrame(() => {
        const { desktopAddToCartCta } = this.$refs
        const desktopAddToCartCtaBottomScroll =
          desktopAddToCartCta.getBoundingClientRect().bottom

        // Show the sticky bar if the user scrolls past the add to cart button
        if (desktopAddToCartCtaBottomScroll <= POSITION_Y_STICKYBAR_DISPLAY) {
          this.showBottomBar = true
        }

        // Hide the sticky bar if the add to cart button is visible
        if (desktopAddToCartCtaBottomScroll > 0) {
          this.showBottomBar = false
        }
      })
    },
  },
}
